// @ts-nocheck
// @ts-expect-error
import VideoLayout from '../../../modules/UI/videolayout/VideoLayout';
import { getParticipantById } from '../base/participants/functions';
import { OPEN_CHAT } from './actionTypes';
// CUSTOM
// @ts-ignore
import { closeChat, setIsPollsTabFocused } from './actions.any';
// @ts-ignore
import { setChatTranslatorStatus } from '../customise/custom/chat/reducer/actions';
// END
export * from './actions.any';
/**
 * Displays the chat panel.
 *
 * @param {Object} participant - The recipient for the private chat.
 * @returns {{
 *     participant: Participant,
 *     type: OPEN_CHAT
 * }}
 */
export function openChat(participant) {
    return function (dispatch) {
        // CUSTOM
        let menuElem = document.getElementsByClassName("bm-menu-wrap");
        if (menuElem) {
            let menuCs = menuElem[0];
            let targetElement = document.getElementsByClassName("bm-burger-button")[0];
            targetElement.classList.add("open-sidebar-menu-button");
            targetElement.style.left = "315px";
            // targetElement.style.top = "16px";
            targetElement.style.transition = "none";
            targetElement.style.opacity = "1000 !important";
        }
        // END
        dispatch({
            participant,
            type: OPEN_CHAT
        });
    };
}
/**
 * Displays the chat panel for a participant identified by an id.
 *
 * @param {string} id - The id of the participant.
 * @returns {{
 *     participant: Participant,
 *     type: OPEN_CHAT
 * }}
 */
export function openChatById(id) {
    return function (dispatch, getState) {
        const participant = getParticipantById(getState(), id);
        return dispatch({
            participant,
            type: OPEN_CHAT
        });
    };
}
/**
 * Toggles display of the chat panel.
 *
 * @returns {Function}
 */
export function toggleChat() {
    return (dispatch, getState) => {
        const isOpen = getState()['features/chat'].isOpen;
        // CUSTOM
        let menuElem = document.getElementsByClassName("bm-menu-wrap");
        if (menuElem) {
            let menuCs = menuElem[0];
            let targetElement = document.getElementsByClassName("bm-burger-button")[0];
            if (isOpen) {
                targetElement.style.left = "0";
                // targetElement.style.top = "40px";
                // targetElement.style.transition = "left 0.4s";
                targetElement.style.opacity = "299 !important";
                targetElement.classList.remove("open-sidebar-menu-button");
            }
            else {
                targetElement.style.left = "315px";
                // targetElement.style.top = "16px";
                targetElement.style.transition = "none";
                targetElement.style.opacity = "1000 !important";
            }
        }
        // END
        if (isOpen) {
            dispatch(closeChat());
            // CUSTOM
            dispatch(setChatTranslatorStatus(false));
            dispatch(setIsPollsTabFocused(false));
            // END
        }
        else {
            dispatch(openChat());
        }
        // Recompute the large video size whenever we toggle the chat, as it takes chat state into account.
        VideoLayout.onResize();
    };
}
